import { create } from "zustand";
import { FilterStateType } from "../types";
import { FormType } from "../schemas";

type FilterStore = {
  filter: FilterStateType;
  setFilter: (partial: Partial<FilterStateType>) => void;
  resetFilter: () => void;
};

type OriginalDataStore = {
  originalData: FormType["detail"];
  setOriginalData: (data: FormType["detail"]) => void;
};

const defaultFilter: FilterStore["filter"] = {
  keyword: "",
  department: "",
  jobpos: "",
  location: "",
  date_start: "",
  date_end: "",
  type: "now",
};

export const useFilterStore = create<FilterStore>((set) => ({
  filter: defaultFilter,

  setFilter: (partial) =>
    set((state) => ({
      filter: { ...state.filter, ...partial },
    })),

  resetFilter: () => set({ filter: defaultFilter }),
}));



export const useOriginalDataStore = create<OriginalDataStore>((set) => ({
  originalData: [],
  setOriginalData: (data) => set({ originalData: data }),
}));


